"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldProgressSpinnerCoreInputs = void 0;
const progress_indicator_inputs_1 = require("./progress-indicator.inputs");
class EmeraldProgressSpinnerCoreInputs extends progress_indicator_inputs_1.EmeraldProgressIndicatorCoreInputs {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.sizeInRem = 1;
        this.showPercentage = false;
    }
}
exports.EmeraldProgressSpinnerCoreInputs = EmeraldProgressSpinnerCoreInputs;
//# sourceMappingURL=progress-spinner.inputs.js.map